/**
 * Name + Calendar fields shared between the new-calendar setup panel and
 * (from Phase 2 onward) the builder's Setup tab, replacing the old
 * MandatoryInformation.js + IntegrationSelect.js pair.
 * Spec: assets/handoffs/design_handoff_new_calendar_page/README.md §4
 *
 * @param {string} name
 * @param {string=} nameError
 * @param {string} integrationUuid
 * @param {string=} integrationError
 * @param {Array<{uuid:string,label:string,healthy:boolean}>} integrationOptions
 * @param {function} onChangeName - (value) => void
 * @param {function} onChangeIntegration - (uuid) => void
 * @param {boolean=false} disabled
 */
import React, { useCallback } from "react";
import Input from "../../theme/untitled/Input/Input";
import CalendarSelect from "../../theme/untitled/CalendarSelect/CalendarSelect";
import styles from "./SetupFields.module.scss";

const SetupFields = ({
  name,
  nameError,
  integrationUuid,
  integrationError,
  integrationOptions,
  onChangeName,
  onChangeIntegration,
  disabled = false,
}) => {
  const onNameInputChange = useCallback(
    (e) => onChangeName(e.target.value),
    [onChangeName]
  );

  return (
    <div className={styles.fields}>
      <Input
        label="Name"
        hint="Only shown to you, in your dashboard."
        error={nameError}
        value={name || ""}
        disabled={disabled}
        onChange={onNameInputChange}
      />
      <CalendarSelect
        label="Data source"
        hint="Where the events come from."
        error={integrationError}
        options={integrationOptions}
        value={integrationUuid}
        disabled={disabled}
        onChange={onChangeIntegration}
        placeholder={"Select data source"}
      />
    </div>
  );
};

export default SetupFields;
